import { memo } from 'react';

import { PrivateWorkspaceAgentPanelMyTasks } from '~/components/v2/components/workspace/workspace-agent-panel/components/tasks/PrivateWorkspaceAgentPanelMyTasks';
import { usePrivateWorkspaceAgentMyTasksSessionRefresh } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/usePrivateWorkspaceAgentMyTasksSessionRefresh';
import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';

export const PrivateWorkspaceAgentPanelMyTasksView = memo(() => {
  const session = usePrivateWorkspaceAgentPanelSession();

  usePrivateWorkspaceAgentMyTasksSessionRefresh({
    refreshSessions: session.refreshSessions,
    sessions: session.sessions,
  });

  return (
    <section
      aria-label="My tasks"
      className="flex min-h-0 flex-1 flex-col"
      data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_VIEW"
    >
      <PrivateWorkspaceAgentPanelMyTasks />
    </section>
  );
});

PrivateWorkspaceAgentPanelMyTasksView.displayName = 'PrivateWorkspaceAgentPanelMyTasksView';
